import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BuildingService } from 'src/app/app/building/building.service';
import { Floor } from 'src/app/app/building/floor/floor.model';
import { CompanyService } from 'src/app/app/company/company.service';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { customValidators } from 'src/app/_helpers/customValidators';
import { globalHelper } from 'src/app/_helpers/global';
import { HeaderService } from 'src/app/_services/header.service';
import { PhotoService } from 'src/app/_services/photo.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { Report } from '../report.model';
import { ReportService } from '../report.service';
@Component({
  selector: 'app-add-report',
  templateUrl: './add-report.page.html',
  styleUrls: ['./add-report.page.scss', './../../../_styles/ion-grid-box.scss'],
  animations: [
    trigger('toggleHeight', [
      state(
        'hasLocations',
        style({
          height: '*',
          opacity: '1',
        })
      ),
      state(
        'hasNotLocation',
        style({
          height: '0',
          opacity: '0',
          margin: '0',
        })
      ),
      transition('hasLocations => hasNotLocation', animate('300ms ease-in')),
      transition('hasNotLocation => hasLocations', animate('300ms ease-out')),
    ]),
  ],
})
export class AddReportPage implements OnInit, AfterViewInit {
  loading: boolean = true;
  previewUrl: any = null;
  mobile = false;
  validationError = false;
  form: FormGroup;
  reportId: string;

  compareWith: any;

  defaultPriority: any;

  headerInit: HeaderModel = {
    title: 'REPORT.ADD_REPORT',
    backDefaultHref: '/app/report',
    showRightButtonsOnlyOnMobile: true,
  };

  constructor(
    public reportServ: ReportService,
    private router: Router,
    public photoService: PhotoService,
    public buildingServ: BuildingService,
    public dictionaryServ: DictionaryService,
    public companyServ: CompanyService,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    private el: ElementRef,
    public p: ThisPlatform,
    private headerServ: HeaderService
  ) {}

  async ngOnInit() {
    this.reportServ.report = new Report();
    this.photoService.fileImage = null;
    this.photoService.currentImage = null;
    this.createForm();

    this.reportServ.report.idBuilding = (
      await this.buildingServ.getUserBuilding()
    ).id;

    this.changeBuilding(this.reportServ.report.idBuilding);

    if (this.dictionaryServ.reportTypeValues.length > 0) {
      this.reportServ.report.type = this.dictionaryServ.reportTypeValues[0].value;
    }
    if (this.dictionaryServ.reportSystemValues.length > 0) {
      this.reportServ.report.system = this.dictionaryServ.reportSystemValues[0].value;
    }
    if (this.dictionaryServ.reportPriorityValues.length > 0) {
      this.reportServ.report.priority = 0;
    }

    this.defaultPriority = this.dictionaryServ.reportPriorityValues.find(
      (el) => el.key === 'Normal' || el.key === 'Normalny'
    );
    this.initForm();
  }

  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
    this.loading = false;
    this.validationError = false;
  }
  ngAfterViewInit() {
    // this.scrollContainer = this.scrollableContent.nativeElement;
  }
  createForm() {
    this.form = new FormGroup({
      number: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.maxLength(20)],
      }),
      building: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      floor: new FormControl(null, {
        updateOn: 'blur',
      }),
      type: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      system: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      priority: new FormControl(null, {
        updateOn: 'blur',
      }),
      title: new FormControl(null, {
        updateOn: 'blur',
        validators: [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
          customValidators.trimValidator(),
        ],
      }),
      description: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.maxLength(1000)],
      }),
      itemImage: new FormControl(null, {
        updateOn: 'blur',
        validators: [
          customValidators.fileMaxSize(10000000),
          customValidators.fileFormat([
            'jpg',
            'png',
            'gif',
            'jfif',
            'pjpeg',
            'jpeg',
            'pjp',
          ]),
        ],
      }),
    });
  }

  initForm() {
    this.form.patchValue({
      building: this.buildingServ.findBuilding(
        this.reportServ.report.idBuilding
      ),
      type: this.dictionaryServ.getDictionaryValue(
        this.dictionaryServ.reportTypeValues,
        this.reportServ.report.type
      ),
      system: this.dictionaryServ.getDictionaryValue(
        this.dictionaryServ.reportSystemValues,
        this.reportServ.report.system
      ),
      priority: this.defaultPriority.value,
    });
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: this.translateService.instant('SAVING'),
      })
      .then((loadingEl) => {
        loadingEl.present();

        const {
          building,
          floor,
          type,
          system,
          priority,
          title,
          description,
        } = this.form.value;

        const formData = new FormData();

        for (let key in this.reportServ.attachmentFiles) {
          formData.append('files', this.reportServ.attachmentFiles[key]);
        }

        this.reportServ.attachmentFiles = [];

        building ? formData.append('idBuilding', building.id) : null;
        floor ? formData.append('idFloor', floor.id) : null;
        type ? formData.append('type', type.value) : null;
        system ? formData.append('system', system.value) : null;
        priority
          ? formData.append('priority', priority)
          : formData.append('priority', JSON.stringify(0));
        title ? formData.append('title', title) : null;
        description ? formData.append('description', description) : null;

        this.reportServ.createReport(formData).subscribe((res) => {
          loadingEl.dismiss();
          this.form.reset();
          this.router.navigateByUrl('app/report');
        });
      });
  }

  onChangeBuilding($event) {
    this.changeBuilding($event.id);
  }

  changeBuilding(buildingId: number) {
    this.companyServ
      .getUserBuildingFloors(buildingId)
      .subscribe((floors: Floor[]) => {
        this.companyServ.userFloors = floors;
      });

    this.form.patchValue({
      floor: null,
    });
  }

  imageUploaded(file: File) {
    this.reportServ.attachmentFiles.push(file);
  }

  imageRemoved(key: number) {
    if (this.reportServ.attachmentFiles.length > key) {
      this.reportServ.attachmentFiles.splice(key, 1);
    }
  }

  selectedPriorityChange(value: number) {
    this.reportServ.report.priority = value;
    this.form.patchValue({ priority: value });
  }
  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }
}
